//QUOTE
export const GET_QUOTES = "/orders"
export const GET_QUOTE_DETAIL = "/quotes"
export const UPDATE_QUOTE_DETAIL = "/quotes"
export const DELETE_QUOTE_DETAIL = "/quotes"

//VECTOR
export const GET_VECTORS = "/vectors"
export const GET_VECTOR_DETAIL = "/vectors"
export const UPDATE_VECTOR_DETAIL = "/vectors"
export const DELETE_VECTOR_DETAIL = "/vectors"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/create-order"
export const UPDATE_ORDER = "/order/update"
export const DELETE_ORDER = "/order/delete"
export const CONVERT_TO_ORDER = "/orders/convert-to-order"


//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const GET_CUSTOMER_DETAILS = "/customer"
export const ADD_NEW_CUSTOMER = "/customers"
export const UPDATE_CUSTOMER = "/customers"
export const UPDATE_CUSTOMER_FIELD = "/update-auth"
export const UPDATE_CUSTOMER_PASSWORD_FIELD = "/update-password"
export const DELETE_CUSTOMER = "/customers"

//EMPLOYEES
export const GET_EMPLOYEES = "/employees"
export const GET_EMPLOYEE = "/employees"
export const ADD_NEW_EMPLOYEE = "/employees"
export const UPDATE_EMPLOYEE = "/employees"
export const DELETE_EMPLOYEE = "/employees"
export const UPDATE_EMPLOYEE_DETAIL = "/employees"

//REPORTS
export const GET_REPORTS = "/report"
export const ADD_NEW_REPORTS = "/report"
export const UPDATE_REPORTS = "/report"
export const DELETE_REPORTS = "/report"

//AUTH
export const GET_AUTH_USERS_DESIGNER = "/designers";
export const GET_AUTH_USERS_SALES = "/assToSalesMan";

//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_JWT_LOGOUT = "/logout"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//Mails
export const GET_INBOX_MAILS = "/inboxmails"
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail"
export const DELETE_INBOX_MAIL = "/delete/inboxmail"

//starred mail
export const GET_STARRED_MAILS = "/starredmails"

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails"

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails"

//Send mail
export const GET_SENT_MAILS = "/sentmails"

//Trash mail
export const GET_TRASH_MAILS = "/trashmails"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"



//CART DATA
export const GET_CART_DATA = "/cart"



//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_HISTORY = "/invoice-history"

export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = "/add/user"
export const UPDATE_USER = "/update/user"
export const DELETE_USER = "/delete/user"

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data"
export const GET_YEARLY_DATA = "/yearly-data"
export const GET_MONTHLY_DATA = "/monthly-data"

export const TOP_SELLING_DATA = "/top-selling-data"

export const GET_EARNING_DATA = "/earning-charts-data"

export const GET_PRODUCT_COMMENTS = "/comments-product"

export const ON_LIKNE_COMMENT = "/comments-product-action"

export const ON_ADD_REPLY = "/comments-product-add-reply"

export const ON_ADD_COMMENT = "/comments-product-add-comment"
export const GET_INVOICE_ID = "/generate-id"
export const SAVE_GENERATED_INVOICE = "/save-generated-invoice"
export const GET_GENERATED_INVOICE = "/get-generated-invoice"
export const POST_GENERATED_INVOICE = "/pay-invoice"

export const PAYMENT_INVOICE = "/invoice"